<template>
    <div class="animated fadeIn">
        <b-card>
            <b-row>
                <b-col md="10">
                    <b-form-group label="Компания: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                        <div class="input-group">
                            <b-form-select id="basicSelect"
                                   @change="applyCompanyFilter()"
                                   :plain="true"
                                   v-model="companyFilter"
                                   :options="getMainCompanies()"
                                   value-field="id"
                                   text-field="title"
                                   value="Please select">
                            </b-form-select>
                            <b-button type="button" variant="secondary" @click="resetCompanyFilter()"> <i class="cui-circle-x icon "></i></b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Активные: " label-for="basicSelect" :label-cols="3" :horizontal="false   ">
                        <div class="input-group">
                            <b-form-checkbox-group stacked id="basicCustomCheckboxes">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="activeFilter" value="1" checked v-model="activeFilter" @change="applyActiveFilter()">
                                    <label class="custom-control-label" for="activeFilter">Показывать только активных пользователей</label>
                                </div>
                            </b-form-checkbox-group>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col align="right" md="2">
                    <b-button type="button" variant="success"  @click='createUser()'><i class="fa fa-add"></i> Создать пользователя</b-button>
                    <br><br>
                </b-col>
            </b-row>
        </b-card>

        <v-server-table :url="apiurl('user/table')"  :columns="columns" :options="options" :theme="theme" id="usersTable" ref="usersTable" class="table table-sm">

            <a href="#" slot="m_disabled" slot-scope="props" @click.prevent="disable(props.row, !!props.row.m_disabled)"  >
                <i class="cui-lightbulb text-secondary fa-lg" v-if="!!props.row.m_disabled"></i>
                <i class="cui-lightbulb text-warning fa-lg" v-if="!props.row.m_disabled"></i>
            </a>

            <router-link :to="{ path: '/admin/user/'+props.row.id }" slot="cmd_edit" slot-scope="props" >
                <i class="fa fa-edit fa-lg text-primary"></i>
            </router-link>

            <a href="#" slot="login_as" slot-scope="props" @click.prevent="loginAs(props.row.id)" v-if="is_admin">
                <i class="icon-login text-primary"></i>
            </a>

            <span slot="role" slot-scope="props" >
                {{ roles[props.row.role_id] }}
            </span>

            <span slot="image" slot-scope="props" >
                <img :src="props.row.image" alt="" />
            </span>

        </v-server-table>

        <p>
            <span class="alert-danger">розовым цветом</span> обозначены пользователи, которые относятся к "дополнительным" компаниям<br>
            Для фильтрации по полям "логин", "ФИО", "телефон" используйте спецсисвол % который обозначает "любые символы"
        </p>
    </div>
</template>

<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import { functions_loaders } from '@/functions_loaders.js';
    import { functions_company } from '@/functions/company.js';
    import { functions_vouchers_view } from '@/functions_vouchers_view.js';
    import {CONSTANTS} from '@/constants';
    import username from '../jsx/users/username'
    import company from '../jsx/users/company'
    import login from '../jsx/users/login'

    Vue.use(ServerTable)

    export default {
        name: 'AdminUsers',
        components: { ServerTable, Event, },
        mixins: [functions, functions_loaders, functions_vouchers_view, functions_company],
        data: function () {
            return {
                columns:[ 'id', 'role', 'login', 'username', 'company', 'phone_mobi', 'local_phone_stat', 'm_disabled', 'cmd_edit', 'login_as'],
                options:{
                    saveState: true,
                    headings: {
                        id: '#',
                        login: 'логин',
                        username: 'ФИО',
                        company: 'компания',
                        phone_mobi: 'телефоны',
                        role: 'роль',
                        local_phone_stat: 'местный тел.',
                        login_as: function(h) { return (
                            <i class="icon-login" title="залогиниться как пользователь"></i>
                        )},
                        cmd_edit: function(h) { return (
                            <i class="fa fa-edit fa-lg" title="редактирование компании"></i>
                        )},
                        m_disabled: function(h) { return (
                            <i class="cui-lightbulb fa-lg" title="включение/отключение пользователя"></i>
                        )}
                    },
                    sortable: ['id', 'login', 'username', 'm_disabled'],
                    filterable: ['id', 'login', 'username', 'phone_mobi', 'local_phone_stat'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: { chunk: 10, edge: false, nav: 'scroll', dropdown:false },
                    templates: {
                        username,
                        company,
                        login,
                    },
                    customFilters: [
                        'company',
                        'active',
                    ],
                    initFilters: {
                        company:this.$store.state.userFilters.companyFilter,
                        active:this.$store.state.userFilters.activeFilter,
                    },
                    perPage:20,
                    perPageValues:[],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                    columnsClasses: {
                        m_disabled: "center",
                        cmd_edit: "center",
                    },
                },
                theme: 'bootstrap4',
                template: 'default',

                activeFilter: true,
                companyFilter: null,
            }
        },
        methods: {
            disable: function(user, state) {
                if (state) {
                    this.enableUser(user.id, function() {
                        user.m_disabled = 0;
                    })
                }
                else {
                    this.disableUser(user.id, function() {
                        user.m_disabled = 1;
                    })
                }
            },
            getMainCompanies: function () {
                return this.companies;
            },
            saveFilter() {
                this.$store.commit('saveUserFilters', {
                    companyFilter:this.companyFilter,
                    activeFilter:this.activeFilter,
                });
            },

            restoreFilter() {
                this.companyFilter = this.$store.state.userFilters.companyFilter;
                if (!this.companyFilter) this.companyFilter=null;

                this.activeFilter = this.$store.state.userFilters.activeFilter;
            },
            createUser: function() {
                this.httpPrepare();
                this.$http.post(this.apiurl('user/create')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.$router.push({path: '/admin/user/'+response.payload.id});
                }, this.httpError)
            },
            applyCompanyFilter: function () {
                this.saveFilter();
                Event.$emit('vue-tables.filter::company', this.companyFilter);
            },
            applyActiveFilter: function () {
                console.log('applyActiveFilter');
                this.saveFilter();
                Event.$emit('vue-tables.filter::active', this.activeFilter);
            },
        },

        computed: {

        },
        created: function() {
            this.loadRoles();
            this.loadCompanies();
            this.restoreFilter();
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        }
    }
</script>
